import React, { useContext, useRef } from "react";
import classes from "./IntegrationConfigPanel.module.css";
import images from "../../assets/images";
import Switch from "../../framework/Switch";
import GlobalContext from "../../framework/GlobalContext";
import { useState } from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import ConfigurationContext from "./ConfigurationContext";
const IntegrationConfigPanel = (props) => {
  const { ENABLE_PLUTUS_INTEGRATION, ENABLE_INNOVITI_INTEGRATION } =
    useSelector(
      (state) =>
        state.commonReducer.tabs[state.commonReducer.activeTabIndex].configData
    );
  const [enableInnoviti, setEnableInnoviti] = useState(
    ENABLE_INNOVITI_INTEGRATION
  );
  const [enablePlutus, setEnablePlutus] = useState(ENABLE_PLUTUS_INTEGRATION);
  const { setCurrentComponent } = useContext(GlobalContext);
  const { formLabels } = useContext(ConfigurationContext);

  const integrationInnovitiEnableRef = useRef();
  const integrationPlutusEnableRef = useRef();
  useEffect(() => {
    setCurrentComponent("integration_config_plutus_enable");
    integrationPlutusEnableRef.current.focus({ preventScroll: true });
  }, [setCurrentComponent]);
  return (
    <div className={classes["integration-config-panel"]}>
      <div className={classes["integration-config-panel-item"]}>
        <div className={classes["integration-config-panel-item-header"]}>
          Payment System
        </div>
        <div className={classes["integration-config-panel-item-body"]}>
          <div className={classes["integration-config-panel-item-card"]}>
            <div className={classes["integration-config-panel-item-card-icon"]}>
              <img
                src={images.pinelabs}
                className={classes["item-card-icon"]}
                alt="Pine Labs"
              />
            </div>
            <div
              className={classes["integration-config-panel-item-card-details"]}
            >
              <div
                className={classes["integration-config-panel-item-card-header"]}
              >
                Pine Labs Plutus
              </div>
              <div
                className={classes["integration-config-panel-item-card-body"]}
              >
                <div
                  className={
                    classes["integration-config-panel-item-card-body-content"]
                  }
                >
                  This setting handles Pine Labs Plutus integration for
                  PharmacyPro.
                </div>
                <div
                  className={
                    classes["integration-config-panel-item-card-body-ctas"]
                  }
                >
                  <Switch
                    id="integration_config_plutus_enable"
                    label={formLabels?.ENABLE_PLUTUS_INTEGRATION?.displayName}
                    checked={enablePlutus}
                    ref={integrationPlutusEnableRef}
                    onFocus={() =>
                      setCurrentComponent("integration_config_plutus_enable")
                    }
                    onChange={(e) => {
                      setEnablePlutus(e.target.checked);
                      props.handleFormChange(
                        "ENABLE_PLUTUS_INTEGRATION",
                        e.target.checked,
                        "integration"
                      );
                    }}
                    inputProps={{
                      "data-markers": JSON.stringify({
                        up: "integration_config_innoviti_enable",
                        down: "integration_config_innoviti_enable",
                        left: "integration_config_innoviti_enable",
                        right: "integration_config_innoviti_enable",
                      }),
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className={classes["integration-config-panel-item-card"]}>
            <div className={classes["integration-config-panel-item-card-icon"]}>
              <img
                src={images.innoviti}
                className={classes["item-card-icon"]}
                alt="Innoviti"
              />
            </div>
            <div
              className={classes["integration-config-panel-item-card-details"]}
            >
              <div
                className={classes["integration-config-panel-item-card-header"]}
              >
                Innoviti
              </div>
              <div
                className={classes["integration-config-panel-item-card-body"]}
              >
                <div
                  className={
                    classes["integration-config-panel-item-card-body-content"]
                  }
                >
                  This setting handles Innoviti integration for PharmacyPro.
                </div>
                <div
                  className={
                    classes["integration-config-panel-item-card-body-ctas"]
                  }
                >
                  <Switch
                    id="integration_config_innoviti_enable"
                    label={formLabels?.ENABLE_INNOVITI_INTEGRATION?.displayName}
                    checked={enableInnoviti}
                    ref={integrationInnovitiEnableRef}
                    onFocus={() =>
                      setCurrentComponent("integration_config_innoviti_enable")
                    }
                    onChange={(e) => {
                      setEnableInnoviti(e.target.checked);
                      props.handleFormChange(
                        "ENABLE_INNOVITI_INTEGRATION",
                        e.target.checked,
                        "integration"
                      );
                    }}
                    inputProps={{
                      "data-markers": JSON.stringify({
                        up: "integration_config_plutus_enable",
                        down: "integration_config_plutus_enable",
                        left: "integration_config_plutus_enable",
                        right: "integration_config_plutus_enable",
                      }),
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div></div>
      </div>
      {/* <div className={classes["integration-config-panel-item"]}>
        <div className={classes["integration-config-panel-item-header"]}>
          Marketplace
        </div>
        <div className={classes["integration-config-panel-item-body"]}></div>
        <div></div>
      </div> */}
    </div>
  );
};

export default IntegrationConfigPanel;
